import axios from "axios"

export default {
  
  generateCurvyShape({ vertixCountFactor, radius, centerX, centerY, growth }) {
    return this.catmullRom2bezier(
      this.generateCoords({ 
        vertixCountFactor, 
        radius, 
        centerX, 
        centerY,
        growth 
      })
    )
  },

  generateCoords({ vertixCountFactor, radius, centerX, centerY, growth }) {
    const coords = []
    if (growth) {
      for (let i = 2; i < 360; i ++) {
        let angle = -0.1 * i
        coords.push({
          x: (growth + radius * angle) * Math.cos(angle) + centerX + this.randomRadiusModifier(growth),
          y: (growth + radius * angle) * Math.sin(angle) + centerY + this.randomRadiusModifier(growth)
        })
      }
      return coords.reverse()
    } else {
      for (let i = 0; i < 2 * Math.PI; i += vertixCountFactor) {
        coords.push({
          x: (radius*Math.cos(i) + centerX) + this.randomRadiusModifier() ,
          y: (radius*Math.sin(i) + centerY) + this.randomRadiusModifier()
        })
        if (i+vertixCountFactor >= 2*Math.PI) {
          coords.push(coords[0])
        }
      }
      return coords
    }
  },

  catmullRom2bezier(coords) {
    let d = ""
    coords.forEach((coord, index, array) => {
      const p = []
      if (index === 0) {
        d += `M${coord.x},${coord.y} `
        p.push(array[array.length - 3])
        p.push(array[index])
        p.push(array[index+1])
        p.push(array[index+2])
      } else if (index === array.length - 2) {
        p.push(array[index-1])
        p.push(array[index])
        p.push(array[index+1])
        p.push(array[0])
      } else if (index === array.length - 1) {
        return
      } else {
        p.push(array[index-1])
        p.push(array[index])
        p.push(array[index+1])
        p.push(array[index+2])
      }
      const bp = []
      bp.push( { x: p[1].x,  y: p[1].y } )
      bp.push( { x: ((-p[0].x + 6*p[1].x + p[2].x) / 6), y: ((-p[0].y + 6*p[1].y + p[2].y) / 6)} )
      bp.push( { x: ((p[1].x + 6*p[2].x - p[3].x) / 6),  y: ((p[1].y + 6*p[2].y - p[3].y) / 6) } )
      bp.push( { x: p[2].x,  y: p[2].y } )
      d += "C" + bp[1].x + "," + bp[1].y + " " + bp[2].x + "," + bp[2].y + " " + bp[3].x + "," + bp[3].y + " "
    })
    return d
  },
  
  randomRadiusModifier(growth) {
    let num = Math.floor(Math.random()*10) + 1
    if (growth) {
      num *= Math.floor(Math.random()*2) == 1 ? growth : -growth  
    } else {
      num *= Math.floor(Math.random()*2) == 1 ? 1: -1
    }
    return num
  },

  getSVG: url => {
    return new Promise ((resolve, reject) => axios
      .get(url)
      .then(res => {
        resolve({
        d: res.data
          .match(/ d="([\s\S]*?)"/g).map(d => d
            .replaceAll(' d="', '')
            .replaceAll('"', '')
          ).join(''),
        viewBox: res.data
          .match(/ viewBox="([\s\S]*?)"/g)[0]
          .replaceAll(' viewBox="', '')
          .replaceAll('"', '')
        })
      }
      )
      .catch(error => 
        reject(error)
      )
    )
  }

}
